import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CellContext } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import DeleteSubscriptionFormModal from 'src/features/subscriptions/components/forms/DeleteSubscriptionFormModal';
import { Subscription } from 'src/features/subscriptions/utils/types';
import UpdateSubscriptionFormModal from 'src/features/subscriptions/components/forms/UpdateSubscriptionFormModal';
import { subscriptionsMessages } from 'src/features/subscriptions/utils/messages';
import { Link } from 'react-router-dom';
import useHasPermissions from 'src/utils/useHasPermissions';
import { PERMISSION } from 'src/features/auth/types';

export default function CellSubscriptionActions({ row }: CellContext<Subscription, unknown>) {
    const { formatMessage } = useIntl();
    const permissionManageSubscription = useHasPermissions([PERMISSION.MANAGE_SUBSCRIPTIONS]);

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <Link to={`/subscriptions/${row.original.id}`}>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EXPAND} />
                            </Button>
                        </Link>
                    </TooltipTrigger>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.dashboard} />
                    </TooltipContent>
                </Tooltip>

                {permissionManageSubscription && (
                    <>
                        <Tooltip>
                            <UpdateSubscriptionFormModal
                                semantics={{
                                    entryName: formatMessage(subscriptionsMessages.subscription).toLowerCase(),
                                }}
                                selectedSubscription={row.original}
                            >
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                                    </Button>
                                </TooltipTrigger>
                            </UpdateSubscriptionFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.edit} />
                            </TooltipContent>
                        </Tooltip>
                        <Tooltip>
                            <DeleteSubscriptionFormModal selectedSubscription={row.original}>
                                <TooltipTrigger asChild>
                                    <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                        <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                                    </Button>
                                </TooltipTrigger>
                            </DeleteSubscriptionFormModal>
                            <TooltipContent>
                                <FormattedMessage {...generalMessages.delete} />
                            </TooltipContent>
                        </Tooltip>
                    </>
                )}
            </TooltipProvider>
        </div>
    );
}
